import { AnchorButton } from '@givebutter/primitives/anchor-button';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BrandIcon } from 'components/brand/BrandIcon';
import { GB_DASHBOARD_URL } from 'lib/constants';

interface NoCampaignsProps {
  accountId: number | null;
  compact?: boolean;
}

export const NoCampaigns = ({ accountId, compact = false }: NoCampaignsProps) => {
  const href = accountId ? `${GB_DASHBOARD_URL}/accounts/${accountId}/campaigns` : GB_DASHBOARD_URL;

  return (
    <div
      className={
        compact
          ? 'flex flex-col items-center gap-3 py-2 text-center'
          : 'flex flex-col items-center gap-4 py-6 text-center'
      }
    >
      {compact ? (
        <>
          <p className="text-center text-xs text-gray-600">
            You&rsquo;ll need a <span className="font-semibold">published</span> campaign on
            Givebutter before you can add a donation widget.
          </p>
          <AnchorButton
            variant="solid"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-lg"
            size="sm"
          >
            Create your first campaign
            <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="size-3.5" />
          </AnchorButton>
        </>
      ) : (
        <>
          <BrandIcon size={56} />
          <div className="flex flex-col gap-1">
            <h2 className="text-lg font-semibold text-gray-900">No campaigns found</h2>
            <p className="max-w-xs text-sm text-gray-500">
              You&rsquo;ll need a <span className="font-semibold">published</span> campaign on
              Givebutter before you can add a donation widget.
            </p>
          </div>
          <AnchorButton
            variant="solid"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-lg"
          >
            Create a campaign
            <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="size-3.5" />
          </AnchorButton>
        </>
      )}
    </div>
  );
};
